'use strict';

function hideDevElements() {
  const queryString = window.location.search;
  const showDev = queryString.includes("?dev");

  if (!showDev) {
    const devElements = document.querySelectorAll("[data-dev]");
    devElements.forEach(element => {
      element.style.display = "none";
    });
  }
}
hideDevElements();

// LazyLoad
lazyLoad();

function isEmpty( el ){
  return !$.trim(el.html())
}

// jQuery functions
$(function () {

  setInterval(function () {
    $('.c-announcements').each(function () {
      var $cur = $(this).find('.is-active').removeClass('is-active');
      var $next = $cur.next().length ? $cur.next() : $(this).children().eq(0);
      $next.addClass('is-active');
    });
  }, 8000);

  // Update price on product pages
  function updatePrice(newPrice) {
    $('[itemprop="price"]').map(function(){
      return $(this).text(newPrice);
    })
  }

  // Relatable Grid - Limit to 3
  $(document).on('relatable:rendered', function (event) {
    $('#relatable-grid li').each(function (count, item) {
      if (count >= 3) {
        item.remove();
      }
    });
  });


  // Mobile nav
  $('.site-header__mobile-toggle').on('click', function (e) {
    $('.mobile-nav').toggleClass('is-open');
    $(this).toggleClass('is-open');
    $('body').toggleClass('menu-is-open');
  });

  // Dropdown nav
  $('.has-children').on('click', function (e) {

    // Reset
    $('.dropdown.is-open').removeClass('is-open');
    $('.has-children.is-active').removeClass('is-active');

    $(this).toggleClass('is-active');
    $('.dropdown__backer').toggleClass('is-active');
    $(this).next('div').toggleClass('is-open');

  });
  $('.dropdown__backer').on('click', function (e) {
    $('.has-children').removeClass('is-active');
    $('.dropdown').removeClass('is-open');
    $(this).removeClass('is-active');
  });

  // Update price ui when qty is changed
  qtyPriceUpdate();

  // Mailchimp subscribe UI
  mceCheck();

  // Giftcard Select
  $('#gift-card-select').on('change', function (e) {
    var selectedProductId = $('#gift-card-select option:selected').val();
    var selectedProductName = $('#gift-card-select option:selected').text();
    $('.product-checkbox__input').val(selectedProductId);
    $('span[itemprop="price"]').text(selectedProductName + '.00');
  });

  // Product image changes when clicked
  productImageNav();

  // Product Variants Filter
  $('.variant-filter__delivery').on('click', function (e) {

    // Reset    
    $('.variant-filter__delivery').removeClass('is-active');
    $('#variant-spaces').prop('selectedIndex', 0)
    $('.options__presentation').show();

    // Activate!
    $(this).addClass('is-active');

    // Hide presentation if 'By post'
    if ($(this).data('filter') == 'By Post') {
      $('.options__presentation').hide();
    }

    // Reset selected option default to first option    
    $('#variant-spaces').trigger('change');

    // Allow Options to be interacted with
    $('.options-row__spaces').addClass('is-active');
  });

  // Only show specific options for each product
  var $selectWrap = $('#variant-spaces');

  // Delivery options
  $('.variant-filter__by-post').click(function () {
    toggleSendFriendBox();
    restoreOptions($selectWrap);
    var $optionsToRemove = $selectWrap.find('option[data-delivery="Instant Download"]');
    removeOptions($selectWrap, $optionsToRemove);
    var selectedProductId = $('#variant-spaces option:first').val();
    $('.product-checkbox__input').val(selectedProductId);
  });

  // Download options
  $('.variant-filter__download').click(function () {
    toggleSendFriendBox();
    restoreOptions($selectWrap);
    var $optionsToRemove = $selectWrap.find('option[data-delivery="By Post"]');
    removeOptions($selectWrap, $optionsToRemove);
    var selectedProductId = $('#variant-spaces option:first').val();
    $('.product-checkbox__input').val(selectedProductId);
  });

  if($('.variant-filter__download').hasClass('is-active')) {
    $('.variant-filter__download').trigger('click');
  }

  // Option types
  $('#variant-spaces').on('change', function (e) {
    var selectedProductId = $(this).find(':selected').val();
    var selectedPrice = $(this).find(':selected').data('price');
    $('.product-checkbox__input').val(selectedProductId);   
    updatePrice(selectedPrice); 
  });

 
  // Delivery Date Dropdown
  const fridayDay = dayjs().day(5);
  const listOfDates = [dayjs(fridayDay).format('ddd DD MMM'), dayjs(fridayDay).add(7, 'day').format('ddd DD MMM'), dayjs(fridayDay).add(14, 'day').format('ddd DD MMM'), dayjs(fridayDay).add(21, 'day').format('ddd DD MMM')];
  
  if(listOfDates.length > 1) {
    $('select#delivery-date').empty();
    $.each(listOfDates, function(i, item ){
      $('select#delivery-date').append($('<option>', {
        value:item,
        text:item
      }));
    })
  }
});


// Send To Friend

// Modal 
$('.send-friend-btn').click(function(e){
  $('.send-friend--wrap').addClass('is-visible');
});

$('.send-friend--wrap').click(function(e){
  $(this).removeClass('is-visible');
})
$('.send-friend').click(function(e){
  e.stopPropagation();
})

$('.send-friend-form a').click(function(e){
  e.preventDefault();
  const email = $('.send-friend-form input[type="email"]').val();
  const name = $('.send-friend-form input[type="text"]').val();
  console.log('Saved:', email, name);

  $(this).text('Saved!');

  $('.send-friend--wrap').removeClass('is-visible');
  $('.send-friend-btn').hide();
  $('.send-friend-edit').show();
});

$('.send-friend-edit').click(function(e){
  e.preventDefault();
  
  $('.send-friend-form :input').val('');
  $('.send-friend-form a').text('Add friend');
  $('.send-friend--wrap').addClass('is-visible');

  $(this).hide();
})

// This covers TWO different types of delivery functional which is stupid but thats how it be sometimes
function toggleSendFriendBox() {
  if($('.variant-filter__by-post').hasClass('is-active') || $('#input-post').is(':checked')) {
    $('.send-friend').hide();
  } else {
    $('.send-friend').show();
  }
}
toggleSendFriendBox();

// HomeKits: Change price on variant
$('.product-checkbox__input').on('click', function (e) {  
  var selectedProductPrice = $(this).data('price');  
  console.log(selectedProductPrice);
  if(selectedProductPrice) {
    $('span[itemprop="price"]').text(selectedProductPrice);
  }  
  toggleSendFriendBox();  
});

// Functions
function setOriginalSelect($select) {
  if ($select.data("originalHTML") == undefined) {
    $select.data("originalHTML", $select.html());
  } // If it's already there, don't re-set it
}

function removeOptions($select, $options) {
  setOriginalSelect($select);
  $options.remove();
}

function restoreOptions($select) {
  var ogHTML = $select.data("originalHTML");
  if (ogHTML != undefined) {
    $select.html(ogHTML);
  }
}

function mceCheck() {
  var mceCheck = $('#mce-CHECK');

  // Allow subcribe only on terms being checked
  mceCheck.on('change', function (e) {
    if ($(this).is(":checked")) {
      $('#mc-embedded-subscribe').removeClass('disabled');
    } else {
      $('#mc-embedded-subscribe').addClass('disabled');
    }
  });

  // Hide success message until UI active
  $("#custom-success").hide();
  $('#mc-embedded-subscribe').on("click", function () {
    $("#custom-success").show();
  });
}
function productImageNav() {
  // Changes main image to thumbnail src when clicked
  $('.product-images__thumbnail-list__link').on('click', function (e) {
    e.preventDefault();
    var image = $(this).attr("href");
    $('.product-images__main__image').attr('src', image);
    $('.product-images__main__link').attr('href', image);
  });
}
function qtyPriceUpdate() {
  // QTY price increase
  var $qtyInput = $('#productQtyInput');
  var $qtyValue = $qtyInput.val();

  $($qtyInput).on('change', function (e) {
    var val = $(this).val();
    var price = $("span[itemprop='price']").attr('data-single-price');

    var newPrice = price * val; // Calculates new price based on qty and formats for currency 
    $("span[itemprop='price']").text("£" + newPrice.toFixed(2)); // Displays new price on DOM
  });
}

function revealMore() {

  $('.reveal-toggle').click(function (e) {
    e.preventDefault();
    $('.product-detail__reveal').toggleClass('is-visible');

    var text = $(this).text();
    if (text === "Read more") {
      $(this).text('Read less');
    } else {
      $(this).text('Read more');
    }
  });
}
function lazyLoad() {
  // Lazy Load
  // Get all of the images that are marked up to lazy load
  var images = document.querySelectorAll('.js-lazy-img');
  var config = {
    // If the image gets within 180px in the Y axis, start the download.
    rootMargin: '180px 0px',
    threshold: 0.01
  };

  var imageCount = images.length;
  var observer = undefined;

  // If we don't have support for intersection observer, loads the images immediately
  if (!('IntersectionObserver' in window)) {
    loadImagesImmediately(images);
  } else {
    // It is supported, load the images
    observer = new IntersectionObserver(onIntersection, config);

    // foreach() is not supported in IE
    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      if (image.classList.contains('js-lazy-img--handled')) {
        continue;
      }

      observer.observe(image);
    }
  }

  /**
   * Fetchs the image for the given URL
   * @param {string} url 
   */
  function fetchImage(url) {
    return new Promise(function (resolve, reject) {
      var image = new Image();
      image.src = url;
      image.onload = resolve;
      image.onerror = reject;
    });
  }

  /**
   * Preloads the image
   * @param {object} image 
   */
  function preloadImage(image) {
    var src = image.dataset.src;
    if (!src) {
      return;
    }

    return fetchImage(src).then(function () {
      applyImage(image, src);
    });
  }

  /**
   * Load all of the images immediately
   * @param {NodeListOf<Element>} images 
   */
  function loadImagesImmediately(images) {
    // foreach() is not supported in IE
    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      preloadImage(image);
    }
  }

  /**
   * Disconnect the observer
   */
  function disconnect() {
    if (!observer) {
      return;
    }

    observer.disconnect();
  }

  /**
   * On intersection
   * @param {array} entries 
   */
  function onIntersection(entries) {
    // Disconnect if we've already loaded all of the images
    if (imageCount === 0) {
      observer.disconnect();
    }

    // Loop through the entries
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      // Are we in viewport?
      if (entry.intersectionRatio > 0) {
        imageCount--;

        // Stop watching and load the image
        observer.unobserve(entry.target);
        preloadImage(entry.target);
      }
    }
  }

  /**
   * Apply the image
   * @param {object} img 
   * @param {string} src 
   */
  function applyImage(img, src) {
    // Prevent this from being lazy loaded a second time.
    img.classList.add('js-lazy-img--handled');
    img.src = src;
  }
}

console.log('JS Loaded!');